// * Hub landing search: send the overview search box to the resources page.
//
// The overview tab (views.view.group_reshub_blocks / ds.field.group_overview)
// renders a plain static form:
//
//   <form role="search" class="hub-search-wrap">
//     <input class="hub-search-input" type="search">
//     <button type="submit" class="hub-search-btn">Search</button>
//   </form>
//
// It has no action, so on its own a submit just reloads the hub landing page.
// This handler intercepts the submit and redirects to /hub/{id}/resources?q=…,
// where the hub_search page picks the query up server-side and seeds
// .hub-search__input with it (see HubSearchController::page).

// Max query length carried over in the URL; longer input is truncated so we
// never build an unbounded query string.
const MAX_QUERY_LENGTH = 200;

/**
 * The hub id from the current path, or null when we are not on a hub page.
 *
 * Matches both the alias (/hub/12/...) and the internal route (/group/12/...).
 */
function hubIdFromPath(pathname) {
  const match = pathname.match(/^\/(?:hub|group)\/(\d+)(?:\/|$)/);
  return match ? match[1] : null;
}

/**
 * Normalizes raw input into a query string value.
 *
 * Collapses all whitespace (\s covers the control characters that matter here)
 * and truncates. This only keeps the URL bounded and tidy — the value is never
 * written back into the DOM as markup, URLSearchParams encodes it, and
 * HubSearchController::sanitizeQuery re-normalizes it server-side.
 */
export function sanitizeQuery(raw) {
  return String(raw ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_QUERY_LENGTH);
}

export function initHubLandingSearch() {
  const forms = document.querySelectorAll('form.hub-search-wrap');
  if (forms.length === 0) {
    return;
  }

  const gid = hubIdFromPath(window.location.pathname);
  if (!gid) {
    return;
  }

  for (const form of forms) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const input = form.querySelector('.hub-search-input');
      const query = sanitizeQuery(input ? input.value : '');

      const url = new URL(`/hub/${gid}/resources`, window.location.origin);
      if (query !== '') {
        url.searchParams.set('q', query);
      }

      window.location.assign(url.toString());
    });
  }
}
